import { MLP_NAVBAR_LOGO } from '@/common/constants';
import React from 'react';
import { DesktopNavbar } from './DesktopNavbar';
import { MobileNavbar } from './MobileNavbar';
import styles from './Navbar.module.scss';
import { NavbarProps } from './types';

export const Navbar: React.FC<NavbarProps> = ({
  title = MLP_NAVBAR_LOGO,
  titleLink = '/',
  navItems,
  ctas,
}) => {
  return (
    <>
      <DesktopNavbar
        title={title}
        titleLink={titleLink}
        navItems={navItems}
        ctas={ctas}
        className={styles.navbar_desktop}
      />
      <MobileNavbar
        title={title}
        titleLink={titleLink}
        navItems={navItems}
        ctas={ctas}
        className={styles.navbar_mobile}
      />
    </>
  );
};
